var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "testimonials container text-center",
      class: _vm.schema.settings.testimonialsLayout,
      style: _vm.paddingStyles
    },
    [
      _c(
        "h3",
        {
          staticClass: "h3 testimonials__title text-center",
          class: _vm.schema.settings.sectionHeaderColor
        },
        [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
      ),
      _c(
        "div",
        { staticClass: "testimonials__testimonials" },
        _vm._l(_vm.schema.blocks, function(block) {
          return _c("article", { staticClass: "testimonials__testimonial" }, [
            _c(
              "div",
              {
                staticClass: "testimonials__inner",
                class: [_vm.schema.settings.testimonialBackgroundColor]
              },
              [
                block.settings.testimonial_logo
                  ? _c("img", {
                      staticClass: "testimonials__img",
                      attrs: {
                        "aria-role": "presentation",
                        src: _vm.imageSize(
                          block.settings.testimonial_logo,
                          "256x256"
                        ),
                        srcset:
                          _vm.imageSize(
                            block.settings.testimonial_logo,
                            "128x128"
                          ) +
                          " 1x, " +
                          _vm.imageSize(
                            block.settings.testimonial_logo,
                            "256x256"
                          ) +
                          " 2x",
                        alt: block.testimonial_logo_alt
                      }
                    })
                  : _vm._e(),
                _c("blockquote", {
                  staticClass: "body-sm testimonials__body",
                  class: _vm.schema.settings.textColor,
                  domProps: {
                    innerHTML: _vm._s(block.settings.testimonial_body)
                  }
                }),
                _c(
                  "p",
                  {
                    staticClass: "h7 testimonials__source",
                    class: _vm.schema.settings.textColor
                  },
                  [_vm._v(_vm._s(block.settings.testimonial_source))]
                )
              ]
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }